// import React, { useEffect, useRef, useState } from "react";
// import { PlusIcon, Spinner } from "../../../../assets/icons/icons";
// import Dropdown from "../../../common/dropdown";
// import Input from "../../../common/input";
// import { useLocation } from "react-router-dom";
// import { useSelectedOption } from "../../../../context/media-context/SelectedOptionContext";

// export default function AddNewCategory({
//   isOpen,
//   onClose,
//   isSavingData,
//   setIsSavingData,
//   data,
//   handleAddNewCategory,
// }) {
//   const { pathname } = useLocation();
//   const isVideoRoute = pathname.includes("videos");

//   console.log(isSavingData);

//   const MAX_FILE_SIZE_IMAGE = 50 * 1024 * 1024; // 5MB
//   const MAX_FILE_SIZE_VIDEO = 200 * 1024 * 1024; // 20MB

//   const MAX_IMAGES = Infinity; // Limit for image uploads
//   const fileRef = useRef(null);
//   const animated_previewRef = useRef(null);

//   const [files, setFiles] = useState([]); // State to hold multiple files

//   const [animated_preview, setAnimated_preview] = useState(null); //state to hold gif or video

//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
//   const { selectedOption, setSelectedOption } = useSelectedOption();
//   const [formData, setFormData] = useState({
//     name: "",
//     category_order: 10,
//     is_top_collection: false,
//     order: "",
//     files: [],
//     animated_preview: "",
//     is_featured: false,
//     is_multifaced: false,
//     is_premium: false,
//     is_trending: false,
//     premiumfor: "ALL",
//   });

//   const [errorMessage, setErrorMessage] = useState({
//     imageError: "",
//     videoError: "",
//     animated_previewError: "",
//     dropdownError: "",
//   });

//   const handleToggleDropdown = () => {
//     setOpenDropdownIndex(!openDropdownIndex);
//   };

//   const closeDialog = () => {
//     setFormData({
//       name: selectedOption,
//       is_top_collection: false,
//       category_order: "",
//       files: [],
//       animated_preview: "",
//       is_featured: false,
//       is_multifaced: false,
//       is_premium: false,
//       is_trending: false,
//       premiumfor: "ALL",
//     });
//     setFiles([]);
//     setAnimated_preview(null);
//     setErrorMessage({ imageError: "", dropdownError: "" });
//     onClose();
//   };

//   const handleChange = (e) => {
//     const { name, type, value, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Validate if an option is selected
//     if (!selectedOption) {
//       setErrorMessage((prevErrors) => ({
//         ...prevErrors,
//         dropdownError: "Please select an option.",
//       }));
//       return;
//     }

//     // Validate if at least one image is uploaded
//     if (files.length === 0) {
//       setErrorMessage((prevErrors) => ({
//         ...prevErrors,
//         imageError: "Please upload at least one image.",
//       }));
//       return;
//     }

//     if (files.length === 1) {
//       if (!animated_preview || !animated_preview.file) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           animated_previewError: "Please upload animated preview.",
//         }));
//         return;
//       }
//     }

//     // Ensure name is set in formData
//     setFormData((prevState) => ({
//       ...prevState,
//       name: selectedOption,
//     }));

//     // Reset error messages
//     setErrorMessage((prevErrors) => ({
//       ...prevErrors,
//       imageError: "",
//       dropdownError: "",
//       animated_previewError: "",
//     }));

//     setIsSavingData(true);
//     handleAddNewCategory(
//       { ...formData, name: selectedOption.label },
//       closeDialog,
//     );
//   };

//   const handleUploadFile = () => {
//     fileRef?.current?.click();
//   };
//   // upload for photo
//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     if (files) {
//       const fileArray = Array.from(files);
//       const invalidFiles = [];

//       if (files.length + fileArray.length > MAX_IMAGES) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           imageError: `Maximum ${MAX_IMAGES} files allowed.`,
//         }));
//         return;
//       }

//       const validImagesPromises = fileArray
//         .filter((file) => {
//           const fileType = file.type.toLowerCase();
//           const isValidType =
//             fileType === "image/jpeg" ||
//             fileType === "image/png" ||
//             fileType === "image/jpg" ||
//             fileType === "image/pjpeg" ||
//             fileType === "image/x-png";
//           const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

//           if (!isValidType) invalidFiles.push(`${file.name} (invalid type)`);
//           if (!isSizeValid) invalidFiles.push(`${file.name} (too large)`);

//           return isValidType && isSizeValid;
//         })
//         .map((file) => {
//           const reader = new FileReader();
//           return new Promise((resolve) => {
//             reader.onloadend = () => resolve({ file, preview: reader.result });
//             reader.readAsDataURL(file);
//           });
//         });

//       if (invalidFiles.length > 0) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           imageError: `Invalid files: ${invalidFiles.join(", ")}`,
//         }));
//       } else {
//         setErrorMessage((prevErrors) => ({ ...prevErrors, imageError: "" }));
//       }

//       if (validImagesPromises.length > 0) {
//         Promise.all(validImagesPromises).then((file) => {
//           const newImagesArray = file.map((img) => img.preview);
//           const newFilesArray = file.map((img) => img.file);

//           setFiles((prevImages) => [...prevImages, ...newImagesArray]);
//           setFormData((prevState) => ({
//             ...prevState,
//             files: [...prevState.files, ...newFilesArray],
//           }));
//         });
//       }
//     }
//   };
//   // upload for vidoe

//   const handleVideoFile = (event) => {
//     const files = event.target.files;

//     if (files) {
//       const fileArray = Array.from(files);
//       const invalidFiles = [];
//       const validVideosPromises = fileArray
//         .filter((file) => {
//           const fileType = file.type.toLowerCase();
//           const isValidType =
//             fileType === "video/mp4" ||
//             fileType === "video/webm" ||
//             fileType === "video/ogg";
//           const isSizeValid = file.size <= MAX_FILE_SIZE_VIDEO;

//           if (!isValidType) invalidFiles.push(`${file.name} (invalid type)`);
//           if (!isSizeValid)
//             invalidFiles.push(
//               `${file.name} is too large. The size should be less than ${MAX_FILE_SIZE_VIDEO}.`,
//             );

//           return isValidType && isSizeValid;
//         })
//         .map((file) => {
//           const reader = new FileReader();
//           return new Promise((resolve) => {
//             reader.onloadend = () => resolve({ file, preview: reader.result });
//             reader.readAsDataURL(file);
//           });
//         });

//       if (invalidFiles.length > 0) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           videoError: `Invalid files: ${invalidFiles.join(", ")}`,
//         }));
//       } else {
//         setErrorMessage((prevErrors) => ({ ...prevErrors, videoError: "" }));
//       }

//       if (validVideosPromises.length > 0) {
//         Promise.all(validVideosPromises).then((videoData) => {
//           const newVideosArray = videoData.map((vid) => vid.preview);
//           const newFilesArray = videoData.map((vid) => vid.file);

//           setFiles((prevVideos) => [...prevVideos, ...newVideosArray]);
//           setFormData((prevState) => ({
//             ...prevState,
//             files: [...prevState.files, ...newFilesArray],
//           }));
//         });
//       }
//     }
//   };

//   const handleanimated_previewUpload = (event) => {
//     const file = event.target.files[0]; // Single file upload for GIF or video
//     if (file) {
//       const fileType = file.type.toLowerCase();
//       const isValidType = fileType === "image/gif";
//       const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

//       if (!isValidType) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           animated_previewError: `${file.name} is an invalid file type.`,
//         }));
//         return;
//       }
//       if (!isSizeValid) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           animated_previewError: `${file.name} is too large.`,
//         }));
//         return;
//       }

//       setErrorMessage((prevErrors) => ({
//         ...prevErrors,
//         animated_previewError: "",
//       }));

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const preview = reader.result;

//         setAnimated_preview({ file, preview });
//         setFormData((prevState) => ({
//           ...prevState,
//           animated_preview: file,
//         }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   useEffect(() => {
//     setFormData((prevState) => ({
//       ...prevState,
//       name: selectedOption,
//     }));
//   }, [selectedOption]);

//   return (
//     <>
//       {isOpen && (
//         <div className="relative z-50">
//           <div
//             className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-[30px] transition-opacity"
//             aria-hidden="true"
//           ></div>

//           <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
//             <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
//               <div className="relative h-[470px] transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[800px]">
//                 <form onSubmit={handleSubmit}>
//                   <div className="p-[24px]">
//                     <h2 className="mb-[20px] text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
//                       Create New
//                     </h2>
//                     <div className="mb-[40px] grid h-fit grid-flow-row grid-cols-2 gap-x-[40px] gap-y-[20px]">
//                       <div className="col-span-2">
//                         <Dropdown
//                           buttonText="Select"
//                           items={data}
//                           className="w-[130px] bg-[#0075FF1A] text-[#000000]"
//                           isOpen={openDropdownIndex}
//                           toggleDropdown={handleToggleDropdown}
//                           shouldNavigate={false}
//                           selectedOption={selectedOption}
//                           setSelectedOption={setSelectedOption}
//                           disabled={isSavingData}
//                           setErrorMessage={setErrorMessage}
//                         />
//                         {errorMessage.dropdownError && (
//                           <p className="mt-1 text-sm text-red-500">
//                             {errorMessage.dropdownError}
//                           </p>
//                         )}
//                       </div>

//                       {/* Input Fields */}
//                       <Input
//                         label="Top Collection"
//                         checked={formData.is_top_collection}
//                         onChange={handleChange}
//                         name="is_top_collection"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         label="Multifaced"
//                         checked={formData.is_multifaced}
//                         onChange={handleChange}
//                         name="is_multifaced"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         label="Premium"
//                         checked={formData.is_premium}
//                         onChange={handleChange}
//                         name="is_premium"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         className="row-span-0"
//                         label="Trending"
//                         checked={formData.is_trending}
//                         onChange={handleChange}
//                         name="is_trending"
//                         type="checkbox"
//                         width="w-[20px]"
//                         disabled={isSavingData}
//                       />
//                       <div>
//                         <Dropdown
//                           name="premiumfor"
//                           value={formData.premiumfor}
//                           onChange={handleChange}
//                           items={[
//                             { category_id: "ALL", category_name: "ALL" },
//                             { category_id: "IOS", category_name: "IOS" },
//                             { category_id: "AND", category_name: "AND" },
//                             { category_id: "WEB", category_name: "WEB" },
//                           ]}
//                           className="w-[200px] bg-[#0075FF1A] text-[#000000]"
//                         />
//                       </div>

//                       <div>
//                         <div
//                           className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
//                           onClick={handleUploadFile}
//                         >
//                           <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
//                             {isVideoRoute ? "Upload Videos" : "Upload Images"}
//                           </p>
//                           <div className="absolute left-[5px] top-1/2 mb-4 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
//                             <PlusIcon />
//                           </div>
//                           <input
//                             type="file"
//                             id="imageUploadInput"
//                             className="hidden"
//                             accept={isVideoRoute ? "video/mp4" : "image/*"}
//                             ref={fileRef}
//                             onChange={
//                               isVideoRoute ? handleVideoFile : handleImageUpload
//                             }
//                             multiple
//                             disabled={isSavingData}
//                           />
//                         </div>

//                         {/* FILE Previews */}
//                         <div className="mb-4 flex h-fit max-h-[300px] flex-col items-center space-y-2 overflow-hidden overflow-y-auto scroll-smooth">
//                           {files.length > 0 && (
//                             <div className="mt-2 grid grid-cols-2 gap-2">
//                               {files.map((file, index) =>
//                                 isVideoRoute ? (
//                                   <video
//                                     key={index}
//                                     src={file}
//                                     className="h-auto w-auto object-cover"
//                                     controls
//                                   />
//                                 ) : (
//                                   <img
//                                     key={index}
//                                     src={file}
//                                     alt="Uploaded Preview"
//                                     className="h-[50px] w-[50px] rounded-full object-cover"
//                                   />
//                                 ),
//                               )}
//                             </div>
//                           )}
//                         </div>

//                         {/* Error Message */}

//                         {isVideoRoute ? (
//                           <>
//                             {errorMessage.videoError && (
//                               <p className="mt-2 text-sm text-red-500">
//                                 {errorMessage.videoError}
//                               </p>
//                             )}
//                           </>
//                         ) : (
//                           <>
//                             {errorMessage.imageError && (
//                               <p className="mt-2 text-sm text-red-500">
//                                 {errorMessage.imageError}
//                               </p>
//                             )}
//                           </>
//                         )}
//                       </div>

//                       {/* Gif image if only one image selected */}
//                       <div>
//                         {formData?.files?.length === 1 && (
//                           <>
//                             <div
//                               className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
//                               onClick={() =>
//                                 animated_previewRef.current.click()
//                               }
//                             >
//                               <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
//                                 Upload GIF or Video
//                               </p>
//                               <div className="absolute left-[5px] top-1/2 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
//                                 <PlusIcon />
//                               </div>
//                               <input
//                                 type="file"
//                                 id="animated_previewUploadInput"
//                                 className="hidden"
//                                 accept="image/gif"
//                                 ref={animated_previewRef}
//                                 onChange={handleanimated_previewUpload}
//                                 disabled={isSavingData}
//                                 aria-label="Upload GIF or Video"
//                               />
//                             </div>

//                             {/* gif  */}
//                             <div className="mt-2">
//                               {animated_preview && animated_preview.preview && (
//                                 <>
//                                   <img
//                                     src={animated_preview.preview}
//                                     alt="Uploaded GIF"
//                                     className="h-[50px] w-[50px] rounded-full object-cover"
//                                   />
//                                 </>
//                               )}
//                             </div>

//                             {/* Error Message */}

//                             {errorMessage.animated_previewError && (
//                               <p className="mt-2 text-sm text-red-500">
//                                 {errorMessage.animated_previewError}
//                               </p>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="flex justify-end space-x-[15px]">
//                       <button
//                         type="button"
//                         className={`${
//                           isSavingData ? "cursor-not-allowed" : "cursor-pointer"
//                         } flex w-[115px] justify-center rounded-md border border-transparent bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 focus:outline-none`}
//                         onClick={closeDialog}
//                         disabled={isSavingData}
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         type="submit"
//                         className="flex w-[115px] justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none"
//                         disabled={isSavingData}
//                       >
//                         {isSavingData ? (
//                           <div className="flex items-center">
//                             <Spinner />
//                             Saving...
//                           </div>
//                         ) : (
//                           "Create"
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { PlusIcon, Spinner } from "../../../../assets/icons/icons";
import Dropdown from "../../../common/dropdown";
import Input from "../../../common/input";
import { useLocation } from "react-router-dom";
import { useSelectedOption } from "../../../../context/media-context/SelectedOptionContext";

export default function AddNewCategory({
  isOpen,
  onClose,
  isSavingData,
  setIsSavingData,
  data,
  handleAddNewCategory,
}) {
  const { pathname } = useLocation();
  const isVideoRoute = pathname.includes("videos");

  const MAX_FILE_SIZE_IMAGE = 50 * 1024 * 1024; // 50MB for images and GIFs
  const MAX_FILE_SIZE_VIDEO = 200 * 1024 * 1024; // 200MB for videos
  const MAX_FILES = Infinity; // Limit for file uploads

  const fileRef = useRef(null);
  const animatedPreviewRef = useRef(null);

  const [files, setFiles] = useState([]); // State to hold multiple files (images or videos)
  const [animatedPreview, setAnimatedPreview] = useState(null); // State for GIF preview
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const { selectedOption, setSelectedOption } = useSelectedOption();

  const [formData, setFormData] = useState({
    name: "",
    category_order: 10,
    is_top_collection: false,
    order: "",
    files: [],
    animated_preview: "",
    is_featured: false,
    is_multifaced: false,
    is_premium: false,
    is_trending: false,
    premiumfor: "ALL",
  });

  const [errorMessage, setErrorMessage] = useState({
    imageError: "",
    videoError: "",
    animatedPreviewError: "",
    dropdownError: "",
  });

  const handleToggleDropdown = () => {
    setOpenDropdownIndex(!openDropdownIndex);
  };

  const closeDialog = () => {
    setFormData({
      name: selectedOption,
      is_top_collection: false,
      category_order: "",
      files: [],
      animated_preview: "",
      is_featured: false,
      is_multifaced: false,
      is_premium: false,
      is_trending: false,
      premiumfor: "ALL",
    });
    setFiles([]);
    setAnimatedPreview(null);
    setErrorMessage({
      imageError: "",
      videoError: "",
      animatedPreviewError: "",
      dropdownError: "",
    });
    onClose();
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // Validate if an option is selected
  //   if (!selectedOption) {
  //     setErrorMessage((prevErrors) => ({
  //       ...prevErrors,
  //       dropdownError: "Please select an option.",
  //     }));
  //     return;
  //   }

  //   // Validate if at least one file is uploaded
  //   if (files.length === 0) {
  //     setErrorMessage((prevErrors) => ({
  //       ...prevErrors,
  //       [isVideoRoute ? "videoError" : "imageError"]:
  //         `Please upload at least one ${isVideoRoute ? "video" : "image"}.`,
  //     }));
  //     return;
  //   }

  //   // Validate animated preview if only one file is uploaded
  //   // if (files.length === 1 && (!animatedPreview || !animatedPreview.file)) {
  //   //   setErrorMessage((prevErrors) => ({
  //   //     ...prevErrors,
  //   //     animatedPreviewError: "Please upload a GIF preview.",
  //   //   }));
  //   //   return;
  //   // }

  //   // Ensure name is set in formData
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     name: selectedOption,
  //   }));

  //   // Reset error messages
  //   setErrorMessage({
  //     imageError: "",
  //     videoError: "",
  //     animatedPreviewError: "",
  //     dropdownError: "",
  //   });

  //   // Prepare form data for API call
  //   setIsSavingData(true);
  //   handleAddNewCategory(
  //     { ...formData, name: selectedOption.label },
  //     closeDialog,
  //   );
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedOption) {
      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        dropdownError: "Please select an option.",
      }));
      return;
    }

    if (files.length === 0) {
      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        [isVideoRoute ? "videoError" : "imageError"]:
          `Please upload at least one ${isVideoRoute ? "video" : "image"}.`,
      }));
      return;
    }

    // GIF preview required when video route and files <= 1
    if (
      isVideoRoute &&
      files.length > 0 &&
      files.length <= 1 &&
      (!animatedPreview || !animatedPreview.file)
    ) {
      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        animatedPreviewError: "Please upload a GIF preview.",
      }));
      return;
    }

    // All good — proceed
    setFormData((prevState) => ({
      ...prevState,
      name: selectedOption,
    }));

    setErrorMessage({
      imageError: "",
      videoError: "",
      animatedPreviewError: "",
      dropdownError: "",
    });

    setIsSavingData(true);
    handleAddNewCategory(
      { ...formData, name: selectedOption.label },
      closeDialog,
    );
  };

  const handleUploadFile = () => {
    fileRef?.current?.click();
  };

  // Handle image upload
  const handleImageUpload = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      const fileArray = Array.from(uploadedFiles);
      const invalidFiles = [];

      if (files.length + fileArray.length > MAX_FILES) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          imageError: `Maximum ${MAX_FILES} images allowed.`,
        }));
        return;
      }

      const validImagesPromises = fileArray
        .filter((file) => {
          const fileType = file.type.toLowerCase();
          const isValidType =
            fileType === "image/jpeg" ||
            fileType === "image/png" ||
            fileType === "image/jpg" ||
            fileType === "image/pjpeg" ||
            fileType === "image/x-png";
          const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

          if (!isValidType) invalidFiles.push(`${file.name} (invalid type)`);
          if (!isSizeValid) invalidFiles.push(`${file.name} (too large)`);

          return isValidType && isSizeValid;
        })
        .map((file) => {
          const reader = new FileReader();
          return new Promise((resolve) => {
            reader.onloadend = () => resolve({ file, preview: reader.result });
            reader.readAsDataURL(file);
          });
        });

      if (invalidFiles.length > 0) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          imageError: `Invalid files: ${invalidFiles.join(", ")}`,
        }));
      } else {
        setErrorMessage((prevErrors) => ({ ...prevErrors, imageError: "" }));
      }

      if (validImagesPromises.length > 0) {
        Promise.all(validImagesPromises).then((fileData) => {
          const newImagesArray = fileData.map((img) => img.preview);
          const newFilesArray = fileData.map((img) => img.file);

          setFiles((prevImages) => [...prevImages, ...newImagesArray]);
          setFormData((prevState) => ({
            ...prevState,
            files: [...prevState.files, ...newFilesArray],
          }));
        });
      }
    }
  };

  // Handle video upload
  const handleVideoUpload = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      const fileArray = Array.from(uploadedFiles);
      const invalidFiles = [];

      if (files.length + fileArray.length > MAX_FILES) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          videoError: `Maximum ${MAX_FILES} videos allowed.`,
        }));
        return;
      }

      const validVideosPromises = fileArray
        .filter((file) => {
          const fileType = file.type.toLowerCase();
          const isValidType =
            fileType === "video/mp4" ||
            fileType === "video/webm" ||
            fileType === "video/ogg";
          const isSizeValid = file.size <= MAX_FILE_SIZE_VIDEO;

          if (!isValidType) invalidFiles.push(`${file.name} (invalid type)`);
          if (!isSizeValid) invalidFiles.push(`${file.name} (too large)`);

          return isValidType && isSizeValid;
        })
        .map((file) => {
          const reader = new FileReader();
          return new Promise((resolve) => {
            reader.onloadend = () => resolve({ file, preview: reader.result });
            reader.readAsDataURL(file);
          });
        });

      if (invalidFiles.length > 0) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          videoError: `Invalid files: ${invalidFiles.join(", ")}`,
        }));
      } else {
        setErrorMessage((prevErrors) => ({ ...prevErrors, videoError: "" }));
      }

      if (validVideosPromises.length > 0) {
        Promise.all(validVideosPromises).then((fileData) => {
          const newVideosArray = fileData.map((vid) => vid.preview);
          const newFilesArray = fileData.map((vid) => vid.file);

          setFiles((prevVideos) => [...prevVideos, ...newVideosArray]);
          setFormData((prevState) => ({
            ...prevState,
            files: [...prevState.files, ...newFilesArray],
          }));
        });
      }
    }
  };

  // Handle GIF preview upload
  const handleAnimatedPreviewUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type.toLowerCase();
      const isValidType = fileType === "image/gif";
      const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

      if (!isValidType) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          animatedPreviewError: `${file.name} is an invalid file type. Only GIF is allowed.`,
        }));
        return;
      }
      if (!isSizeValid) {
        setErrorMessage((prevErrors) => ({
          ...prevErrors,
          animatedPreviewError: `${file.name} is too large.`,
        }));
        return;
      }

      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        animatedPreviewError: "",
      }));

      const reader = new FileReader();
      reader.onloadend = () => {
        const preview = reader.result;
        setAnimatedPreview({ file, preview });
        setFormData((prevState) => ({
          ...prevState,
          animated_preview: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      name: selectedOption,
    }));
  }, [selectedOption]);

  console.log({ files });

  return (
    <>
      {isOpen && (
        <div className="relative z-50">
          <div
            className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-[30px] transition-opacity"
            aria-hidden="true"
          ></div>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div className="relative h-[470px] transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[800px]">
                <form onSubmit={handleSubmit}>
                  <div className="p-[24px]">
                    <h2 className="mb-[20px] text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
                      Create New
                    </h2>
                    <div className="mb-[40px] grid h-fit grid-flow-row grid-cols-2 gap-x-[40px] gap-y-[20px]">
                      <div className="col-span-2">
                        <Dropdown
                          buttonText="Select"
                          items={data}
                          className="w-[130px] bg-[#0075FF1A] text-[#000000]"
                          isOpen={openDropdownIndex}
                          toggleDropdown={handleToggleDropdown}
                          shouldNavigate={false}
                          selectedOption={selectedOption}
                          setSelectedOption={setSelectedOption}
                          disabled={isSavingData}
                          setErrorMessage={setErrorMessage}
                        />
                        {errorMessage.dropdownError && (
                          <p className="mt-1 text-sm text-red-500">
                            {errorMessage.dropdownError}
                          </p>
                        )}
                      </div>

                      {/* Input Fields */}
                      <Input
                        label="Top Collection"
                        checked={formData.is_top_collection}
                        onChange={handleChange}
                        name="is_top_collection"
                        type="checkbox"
                        disabled={isSavingData}
                        width="w-[20px]"
                      />
                      <Input
                        label="Multifaced"
                        checked={formData.is_multifaced}
                        onChange={handleChange}
                        name="is_multifaced"
                        type="checkbox"
                        disabled={isSavingData}
                        width="w-[20px]"
                      />
                      <Input
                        label="Premium"
                        checked={formData.is_premium}
                        onChange={handleChange}
                        name="is_premium"
                        type="checkbox"
                        disabled={isSavingData}
                        width="w-[20px]"
                      />
                      <Input
                        className="row-span-0"
                        label="Trending"
                        checked={formData.is_trending}
                        onChange={handleChange}
                        name="is_trending"
                        type="checkbox"
                        width="w-[20px]"
                        disabled={isSavingData}
                      />
                      <div>
                        <Dropdown
                          name="premiumfor"
                          value={formData.premiumfor}
                          onChange={handleChange}
                          items={[
                            { category_id: "ALL", category_name: "ALL" },
                            { category_id: "IOS", category_name: "IOS" },
                            { category_id: "AND", category_name: "AND" },
                            { category_id: "WEB", category_name: "WEB" },
                          ]}
                          className="w-[200px] bg-[#0075FF1A] text-[#000000]"
                        />
                      </div>

                      {/* File Upload Section */}
                      <div>
                        <div
                          className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
                          onClick={handleUploadFile}
                        >
                          <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
                            {isVideoRoute ? "Upload Videos" : "Upload Images"}
                          </p>
                          <div className="absolute left-[5px] top-1/2 mb-4 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
                            <PlusIcon />
                          </div>
                          <input
                            type="file"
                            id="fileUploadInput"
                            className="hidden"
                            accept={
                              isVideoRoute
                                ? "video/mp4,video/webm,video/ogg"
                                : "image/jpeg,image/png,image/jpg,image/pjpeg,image/x-png"
                            }
                            ref={fileRef}
                            onChange={
                              isVideoRoute
                                ? handleVideoUpload
                                : handleImageUpload
                            }
                            multiple
                            disabled={isSavingData}
                          />
                        </div>

                        {/* File Previews */}
                        {/* <div className="mb-4 flex h-fit max-h-[300px] flex-col items-center space-y-2 overflow-hidden overflow-y-auto scroll-smooth">
                          {files.length > 0 && (
                            <div className="mt-2">
                              {files.length > 1 && isVideoRoute ? (
                                <div className="space-y-1">
                                  {files.map((file, index) => (
                                    <p
                                      key={index}
                                      className="text-[13px] text-gray-700"
                                    >
                                      {typeof file === "string"
                                        ? file.split("/").pop() // if src string — get file name
                                        : file.name}
                                    </p>
                                  ))}
                                </div>
                              ) : (
                                <div className="grid grid-cols-2 gap-2">
                                  {files.map((file, index) =>
                                    isVideoRoute ? (
                                      <video
                                        key={index}
                                        src={file}
                                        className="h-[50px] w-[50px] rounded-full object-cover"
                                        controls
                                      />
                                    ) : (
                                      <img
                                        key={index}
                                        src={file}
                                        alt="Uploaded Preview"
                                        className="h-[50px] w-[50px] rounded-full object-cover"
                                      />
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div> */}
                        <div className="mb-4 flex h-fit max-h-[300px] flex-col items-center space-y-2 overflow-hidden overflow-y-auto scroll-smooth">
                          {files.length > 0 && (
                            <div className="mt-2 grid grid-cols-2 gap-2">
                              {files.map((file, index) =>
                                isVideoRoute ? (
                                  <video
                                    key={index}
                                    src={file}
                                    className="h-[50px] w-[50px] rounded-full object-cover"
                                    controls
                                  />
                                ) : (
                                  <img
                                    key={index}
                                    src={file}
                                    alt="Uploaded Preview"
                                    className="h-[50px] w-[50px] rounded-full object-cover"
                                  />
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        {/* Error Messages */}
                        {errorMessage.imageError && !isVideoRoute && (
                          <p className="mt-2 text-sm text-red-500">
                            {errorMessage.imageError}
                          </p>
                        )}
                        {errorMessage.videoError && isVideoRoute && (
                          <p className="mt-2 text-sm text-red-500">
                            {errorMessage.videoError}
                          </p>
                        )}
                      </div>

                      {/* GIF Preview Upload */}
                      {isVideoRoute && files.length <= 1 && (
                        <div>
                          <div
                            className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
                            onClick={() => animatedPreviewRef.current.click()}
                          >
                            <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
                              Upload GIF Preview
                            </p>
                            <div className="absolute left-[5px] top-1/2 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
                              <PlusIcon />
                            </div>
                            <input
                              type="file"
                              id="animatedPreviewUploadInput"
                              className="hidden"
                              accept="image/gif"
                              ref={animatedPreviewRef}
                              onChange={handleAnimatedPreviewUpload}
                              disabled={isSavingData}
                              aria-label="Upload GIF Preview"
                            />
                          </div>

                          {/* GIF Preview */}
                          <div className="mt-2">
                            {animatedPreview && animatedPreview.preview && (
                              <img
                                src={animatedPreview.preview}
                                alt="Uploaded GIF Preview"
                                className="h-[50px] w-[50px] rounded-full object-cover"
                              />
                            )}
                          </div>

                          {/* Error Message */}
                          {errorMessage.animatedPreviewError && (
                            <p className="mt-2 text-sm text-red-500">
                              {errorMessage.animatedPreviewError}
                            </p>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-end space-x-[15px]">
                      <button
                        type="button"
                        className={`${
                          isSavingData ? "cursor-not-allowed" : "cursor-pointer"
                        } flex w-[115px] justify-center rounded-md border border-transparent bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 focus:outline-none`}
                        onClick={closeDialog}
                        disabled={isSavingData}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="flex w-[115px] justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none"
                        disabled={isSavingData}
                      >
                        {isSavingData ? (
                          <div className="flex items-center">
                            <Spinner />
                            Saving...
                          </div>
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// import React, { useEffect, useRef, useState } from "react";
// import { PlusIcon, Spinner } from "../../../../assets/icons/icons";
// import Dropdown from "../../../common/dropdown";
// import Input from "../../../common/input";
// import { useSelectedOption } from "../../../../context/media-context/SelectedOptionContext";
// import { useLocation } from "react-router-dom";

// export default function AddNewCategory({
//   isOpen,
//   onClose,
//   isSavingData,
//   setIsSavingData,
//   data,
//   handleAddNewCategory,
// }) {
//   const MAX_FILE_SIZE_IMAGE = 50 * 1024 * 1024; // 50MB
//   const MAX_IMAGES = Infinity; // Limit for image uploads
//   const fileRef = useRef(null);
//   const animated_previewRef = useRef(null);

//   const { pathname } = useLocation();
//   const isVideoRoute = pathname.includes("videos");

//   const [files, setFiles] = useState([]); // State to hold multiple images
//   const [animated_preview, setAnimated_preview] = useState([]); // State for GIF preview
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
//   const { selectedOption, setSelectedOption } = useSelectedOption();
//   const [formData, setFormData] = useState({
//     name: "",
//     category_order: 10,
//     is_top_collection: false,
//     order: "",
//     files: [],
//     animated_preview: "",
//     is_featured: false,
//     is_multifaced: false,
//     is_premium: false,
//     is_trending: false,
//     premiumfor: "ALL",
//   });

//   const [errorMessage, setErrorMessage] = useState({
//     imageError: "",
//     animated_previewError: "",
//     dropdownError: "",
//   });

//   const handleToggleDropdown = () => {
//     setOpenDropdownIndex(!openDropdownIndex);
//   };

//   const closeDialog = () => {
//     setFormData({
//       name: selectedOption,
//       is_top_collection: false,
//       category_order: "",
//       files: [],
//       animated_preview: "",
//       is_featured: false,
//       is_multifaced: false,
//       is_premium: false,
//       is_trending: false,
//       premiumfor: "ALL",
//     });
//     setFiles([]);
//     setAnimated_preview(null);
//     setErrorMessage({
//       imageError: "",
//       dropdownError: "",
//       animated_previewError: "",
//     });
//     onClose();
//   };

//   const handleChange = (e) => {
//     const { name, type, value, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Validate if an option is selected
//     if (!selectedOption) {
//       setErrorMessage((prevErrors) => ({
//         ...prevErrors,
//         dropdownError: "Please select an option.",
//       }));
//       return;
//     }

//     // Validate if at least one image is uploaded

//     if (!isVideoRoute) {
//       if (files.length === 0) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           imageError: "Please upload at least one image.",
//         }));
//         return;
//       }
//     }

//     console.log("enter");

//     // Validate animated preview if only one image is uploaded
//     // if (files.length === 1 && (!animated_preview || !animated_preview.file)) {
//     //   setErrorMessage((prevErrors) => ({
//     //     ...prevErrors,
//     //     animated_previewError: "Please upload a GIF preview.",
//     //   }));
//     //   return;
//     // }

//     // Ensure name is set in formData
//     setFormData((prevState) => ({
//       ...prevState,
//       name: selectedOption,
//     }));

//     // Reset error messages
//     setErrorMessage({
//       imageError: "",
//       dropdownError: "",
//       animated_previewError: "",
//     });

//     // Prepare form data for API call
//     setIsSavingData(true);
//     handleAddNewCategory(
//       { ...formData, name: selectedOption.label },
//       closeDialog,
//     );
//     console.log(formData);
//   };

//   const handleUploadFile = () => {
//     fileRef?.current?.click();
//   };

//   // Handle image upload
//   const handleImageUpload = (event) => {
//     const uploadedFiles = event.target.files;
//     if (uploadedFiles) {
//       const fileArray = Array.from(uploadedFiles);
//       const invalidFiles = [];

//       if (files.length + fileArray.length > MAX_IMAGES) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           imageError: `Maximum ${MAX_IMAGES} images allowed.`,
//         }));
//         return;
//       }

//       const validImagesPromises = fileArray
//         .filter((file) => {
//           const fileType = file.type.toLowerCase();
//           const isValidType =
//             fileType === "image/jpeg" ||
//             fileType === "image/png" ||
//             fileType === "image/jpg" ||
//             fileType === "image/pjpeg" ||
//             fileType === "image/x-png";
//           const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

//           if (!isValidType) invalidFiles.push(`${file.name} (invalid type)`);
//           if (!isSizeValid) invalidFiles.push(`${file.name} (too large)`);

//           return isValidType && isSizeValid;
//         })
//         .map((file) => {
//           const reader = new FileReader();
//           return new Promise((resolve) => {
//             reader.onloadend = () => resolve({ file, preview: reader.result });
//             reader.readAsDataURL(file);
//           });
//         });

//       if (invalidFiles.length > 0) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           imageError: `Invalid files: ${invalidFiles.join(", ")}`,
//         }));
//       } else {
//         setErrorMessage((prevErrors) => ({ ...prevErrors, imageError: "" }));
//       }

//       if (validImagesPromises.length > 0) {
//         Promise.all(validImagesPromises).then((fileData) => {
//           const newImagesArray = fileData.map((img) => img.preview);
//           const newFilesArray = fileData.map((img) => img.file);

//           setFiles((prevImages) => [...prevImages, ...newImagesArray]);
//           setFormData((prevState) => ({
//             ...prevState,
//             files: [...prevState.files, ...newFilesArray],
//           }));
//         });
//       }
//     }
//   };

//   // Handle GIF preview upload
//   // const handleAnimatedPreviewUpload = (event) => {
//   //   const file = event.target.files[0];
//   //   if (file) {
//   //     const fileType = file.type.toLowerCase();
//   //     const isValidType = fileType === "image/gif";
//   //     const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

//   //     if (!isValidType) {
//   //       setErrorMessage((prevErrors) => ({
//   //         ...prevErrors,
//   //         animated_previewError: `${file.name} is an invalid file type.`,
//   //       }));
//   //       return;
//   //     }
//   //     if (!isSizeValid) {
//   //       setErrorMessage((prevErrors) => ({
//   //         ...prevErrors,
//   //         animated_previewError: `${file.name} is too large.`,
//   //       }));
//   //       return;
//   //     }

//   //     setErrorMessage((prevErrors) => ({
//   //       ...prevErrors,
//   //       animated_previewError: "",
//   //     }));

//   //     const reader = new FileReader();
//   //     reader.onloadend = () => {
//   //       const preview = reader.result;
//   //       setAnimated_preview({ file, preview });
//   //       setFormData((prevState) => ({
//   //         ...prevState,
//   //         animated_preview: file,
//   //       }));
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };

//   const handleAnimatedPreviewUpload = (event) => {
//     const files = Array.from(event.target.files);

//     files.forEach((file) => {
//       const fileType = file.type.toLowerCase();
//       const isValidType =
//         fileType === "image/gif" ||
//         fileType === "video/mp4" ||
//         fileType === "video/webm" ||
//         fileType === "video/ogg";

//       const isSizeValid = file.size <= MAX_FILE_SIZE_IMAGE;

//       if (!isValidType) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           animated_previewError: `${file.name} is an invalid file type.`,
//         }));
//         return;
//       }

//       if (!isSizeValid) {
//         setErrorMessage((prevErrors) => ({
//           ...prevErrors,
//           animated_previewError: `${file.name} is too large.`,
//         }));
//         return;
//       }

//       setErrorMessage((prevErrors) => ({
//         ...prevErrors,
//         animated_previewError: "",
//       }));

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const preview = reader.result;

//         setAnimated_preview((prev) => [
//           ...prev,
//           { file, preview, type: fileType },
//         ]);

//         setFormData((prevState) => ({
//           ...prevState,
//           animated_previews: [...(prevState.animated_previews || []), file],
//         }));
//       };

//       reader.readAsDataURL(file);
//     });

//     // Reset input to allow re-selecting the same files if needed
//     event.target.value = "";
//   };

//   useEffect(() => {
//     setFormData((prevState) => ({
//       ...prevState,
//       name: selectedOption,
//     }));
//   }, [selectedOption]);

//   return (
//     <>
//       {isOpen && (
//         <div className="relative z-50">
//           <div
//             className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-[30px] transition-opacity"
//             aria-hidden="true"
//           ></div>

//           <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
//             <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
//               <div className="relative h-[470px] transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[800px]">
//                 <form onSubmit={handleSubmit}>
//                   <div className="p-[24px]">
//                     <h2 className="mb-[20px] text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
//                       Create New
//                     </h2>
//                     <div className="mb-[40px] grid h-fit grid-flow-row grid-cols-2 gap-x-[40px] gap-y-[20px]">
//                       <div className="col-span-2">
//                         <Dropdown
//                           buttonText="Select"
//                           items={data}
//                           className="w-[130px] bg-[#0075FF1A] text-[#000000]"
//                           isOpen={openDropdownIndex}
//                           toggleDropdown={handleToggleDropdown}
//                           shouldNavigate={false}
//                           selectedOption={selectedOption}
//                           setSelectedOption={setSelectedOption}
//                           disabled={isSavingData}
//                           setErrorMessage={setErrorMessage}
//                         />
//                         {errorMessage.dropdownError && (
//                           <p className="mt-1 text-sm text-red-500">
//                             {errorMessage.dropdownError}
//                           </p>
//                         )}
//                       </div>

//                       {/* Input Fields */}
//                       <Input
//                         label="Top Collection"
//                         checked={formData.is_top_collection}
//                         onChange={handleChange}
//                         name="is_top_collection"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         label="Multifaced"
//                         checked={formData.is_multifaced}
//                         onChange={handleChange}
//                         name="is_multifaced"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         label="Premium"
//                         checked={formData.is_premium}
//                         onChange={handleChange}
//                         name="is_premium"
//                         type="checkbox"
//                         disabled={isSavingData}
//                         width="w-[20px]"
//                       />
//                       <Input
//                         className="row-span-0"
//                         label="Trending"
//                         checked={formData.is_trending}
//                         onChange={handleChange}
//                         name="is_trending"
//                         type="checkbox"
//                         width="w-[20px]"
//                         disabled={isSavingData}
//                       />
//                       <div>
//                         <Dropdown
//                           name="premiumfor"
//                           value={formData.premiumfor}
//                           onChange={handleChange}
//                           items={[
//                             { category_id: "ALL", category_name: "ALL" },
//                             { category_id: "IOS", category_name: "IOS" },
//                             { category_id: "AND", category_name: "AND" },
//                             { category_id: "WEB", category_name: "WEB" },
//                           ]}
//                           className="w-[200px] bg-[#0075FF1A] text-[#000000]"
//                         />
//                       </div>

//                       {!isVideoRoute && (
//                         <>
//                           <div>
//                             <div
//                               className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
//                               onClick={handleUploadFile}
//                             >
//                               <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
//                                 Upload Images
//                               </p>
//                               <div className="absolute left-[5px] top-1/2 mb-4 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
//                                 <PlusIcon />
//                               </div>
//                               <input
//                                 type="file"
//                                 id="imageUploadInput"
//                                 className="hidden"
//                                 accept="image/*"
//                                 ref={fileRef}
//                                 onChange={handleImageUpload}
//                                 multiple
//                                 disabled={isSavingData}
//                               />
//                             </div>

//                             {/* Image Previews */}
//                             <div className="mb-4 flex h-fit max-h-[300px] flex-col items-center space-y-2 overflow-hidden overflow-y-auto scroll-smooth">
//                               {files.length > 0 && (
//                                 <div className="mt-2 grid grid-cols-2 gap-2">
//                                   {files.map((file, index) => (
//                                     <img
//                                       key={index}
//                                       src={file}
//                                       alt="Uploaded Preview"
//                                       className="h-[50px] w-[50px] rounded-full object-cover"
//                                     />
//                                   ))}
//                                 </div>
//                               )}
//                             </div>

//                             {/* Error Message */}
//                             {errorMessage.imageError && (
//                               <p className="mt-2 text-sm text-red-500">
//                                 {errorMessage.imageError}
//                               </p>
//                             )}
//                           </div>
//                         </>
//                       )}

//                       {/* GIF preview if only one image selected */}
//                       <div>
//                         {isVideoRoute && (
//                           <>
//                             <div
//                               className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
//                               onClick={() =>
//                                 animated_previewRef.current.click()
//                               }
//                             >
//                               <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
//                                 Upload GIF
//                               </p>
//                               <div className="absolute left-[5px] top-1/2 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
//                                 <PlusIcon />
//                               </div>
//                               <input
//                                 type="file"
//                                 id="animated_previewUploadInput"
//                                 className="hidden"
//                                 accept="image/gif"
//                                 ref={animated_previewRef}
//                                 onChange={handleAnimatedPreviewUpload}
//                                 disabled={isSavingData}
//                                 aria-label="Upload GIF"
//                               />
//                             </div>

//                             {/* GIF Preview */}
//                             <div className="mt-2">
//                               {animated_preview && animated_preview.preview && (
//                                 <img
//                                   src={animated_preview.preview}
//                                   alt="Uploaded GIF"
//                                   className="h-[50px] w-[50px] rounded-full object-cover"
//                                 />
//                               )}
//                             </div>

//                             {/* Error Message */}
//                             {errorMessage.animated_previewError && (
//                               <p className="mt-2 text-sm text-red-500">
//                                 {errorMessage.animated_previewError}
//                               </p>
//                             )}
//                             <>
//                               {/* <div
//                                 className="relative w-full max-w-[356px] cursor-pointer rounded-[10px] border border-[#0075FF1A]"
//                                 onClick={() =>
//                                   animated_previewRef.current.click()
//                                 }
//                               >
//                                 <p className="px-[59px] py-[13px] text-center font-outfit text-[14px] leading-[17.64px] text-[#0075FF]">
//                                   Upload GIF or Video
//                                 </p>
//                                 <div className="absolute left-[5px] top-1/2 flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-[6px] bg-[#0075FF1A]">
//                                   <PlusIcon />
//                                 </div> */}
//                               {/* <input
//                                   type="file"
//                                   id="animated_previewUploadInput"
//                                   className="hidden"
//                                   accept="image/gif"
//                                   ref={animated_previewRef}
//                                   onChange={handleAnimatedPreviewUpload}
//                                   disabled={isSavingData}
//                                   aria-label="Upload GIF or Video"
//                                   multiple
//                                 /> */}
//                               {/* <input
//                                   type="file"
//                                   id="animated_previewUploadInput"
//                                   className="hidden"
//                                   accept="image/gif,video/mp4,video/webm,video/ogg"
//                                   ref={animated_previewRef}
//                                   onChange={handleAnimatedPreviewUpload}
//                                   disabled={isSavingData}
//                                   multiple
//                                 />
//                               </div> */}

//                               {/* gif  */}
//                               {/* <div className="mt-2">
//                                 {animated_preview &&
//                                   animated_preview.preview && (
//                                     <>
//                                       <img
//                                         src={animated_preview.preview}
//                                         alt="Uploaded GIF"
//                                         className="h-[50px] w-[50px] rounded-full object-cover"
//                                       />
//                                     </>
//                                   )}
//                               </div> */}
//                               {/* <div className="mt-2 flex flex-wrap gap-3">
//                                 {animated_preview?.map((item, idx) => (
//                                   <div key={idx} className="relative">
//                                     {item.type.startsWith("image/") ? (
//                                       <img
//                                         src={item.preview}
//                                         alt={`Preview ${idx}`}
//                                         className="h-[50px] w-[50px] rounded-full object-cover"
//                                       />
//                                     ) : (
//                                       <video
//                                         src={item.preview}
//                                         controls
//                                         className="h-[50px] w-[50px] rounded-full object-cover"
//                                       />
//                                     )}
//                                   </div>
//                                 ))}
//                               </div> */}

//                               {/* Error Message */}

//                               {/* {errorMessage.animated_previewError && (
//                                 <p className="mt-2 text-sm text-red-500">
//                                   {errorMessage.animated_previewError}
//                                 </p>
//                               )} */}
//                             </>
//                           </>
//                         )}
//                       </div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="flex justify-end space-x-[15px]">
//                       <button
//                         type="button"
//                         className={`${
//                           isSavingData ? "cursor-not-allowed" : "cursor-pointer"
//                         } flex w-[115px] justify-center rounded-md border border-transparent bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 focus:outline-none`}
//                         onClick={closeDialog}
//                         disabled={isSavingData}
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         type="submit"
//                         className="flex w-[115px] justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none"
//                         disabled={isSavingData}
//                       >
//                         {isSavingData ? (
//                           <div className="flex items-center">
//                             <Spinner />
//                             Saving...
//                           </div>
//                         ) : (
//                           "Create"
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }
